import SectionHeader from "./SectionHeader";

const PRINCIPLES = [
  { icon: "ri-eye-off-line", title: "匿名化叙事", desc: "不指名道姓、不做个人定性，只记录可被验证的粉丝反应与舆情模式。" },
  { icon: "ri-git-merge-line", title: "多信源交叉", desc: "结论尽量来自多平台、多方公开信源，单一截图与匿名爆料只作线索提示。" },
  { icon: "ri-scales-line", title: "事实与情绪分开", desc: "把客观事实与主观情绪分别标注，避免回踩长文与洗白话术互相污染判断。" },
  { icon: "ri-time-line", title: "以官方为准", desc: "涉及事实认定的内容，以官方通报与权威信源为准，我们不抢先给结论。" },
];

const metrics = [
  { value: "24h", label: "热点反应周期观测" },
  { value: "72h", label: "典型舆论完整循环" },
  { value: "6 类", label: "粉圈风向维度" },
];

export default function About() {
  return (
    <section id="about" className="bg-background-100">
      <div className="mx-auto max-w-[1280px] px-4 py-14 md:px-6 md:py-20">
        <SectionHeader
          eyebrow="关于本站"
          title="星闻雷达：只做粉丝反应的冷静记录者"
          description="我们不追逐艺人八卦本身，只追踪塌房发生后粉丝立场如何转变、舆论体温如何起落——把「吃瓜」翻译成能读懂的情绪与结构。"
          align="center"
        />

        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-12">
          {/* principles */}
          <div className="lg:col-span-7">
            <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
              {PRINCIPLES.map((p) => (
                <article
                  key={p.title}
                  className="flex flex-col rounded-xl border border-background-200 bg-background-50 p-5"
                >
                  <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-100 text-xl text-accent-700">
                    <i className={p.icon} aria-hidden="true"></i>
                  </span>
                  <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{p.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-700">{p.desc}</p>
                </article>
              ))}
            </div>
          </div>

          {/* intro + contact */}
          <div className="lg:col-span-5">
            <div className="flex h-full flex-col justify-between rounded-xl bg-primary-500 p-6 text-background-50 md:p-7">
              <div>
                <p className="text-[15px] leading-relaxed text-background-50/90">
                  星闻雷达是一份聚焦「明星塌房后的粉圈反应」的中文舆论观察栏目。我们相信，最真实的舆论体温，
                  往往藏在那些不发声的取关、反复改口的声明，以及深夜清空的账号里。
                </p>
                <dl className="mt-6 grid grid-cols-3 gap-4 border-t border-background-50/20 pt-5">
                  {metrics.map((m) => (
                    <div key={m.label}>
                      <dd className="font-heading text-2xl font-bold text-background-50">{m.value}</dd>
                      <dt className="mt-1 text-xs leading-snug text-background-50/75">{m.label}</dt>
                    </div>
                  ))}
                </dl>
              </div>
              <div className="mt-6">
                <p className="text-xs tracking-wide text-background-50/75">投稿 / 线索 / 建议</p>
                <a
                  href="mailto:hello@xingwenradar.cn"
                  className="mt-1 inline-flex items-center gap-2 font-heading text-lg font-bold text-background-50 transition-opacity hover:opacity-80"
                >
                  hello@xingwenradar.cn
                  <i className="ri-mail-line" aria-hidden="true"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}